import React from 'react';
import { profile } from '../mock';
import { Mail, Phone, ArrowUpRight } from 'lucide-react';

export default function Hero() {
  return (
    <section id="top" className="relative pt-[120px] pb-20 lg:pt-[160px] lg:pb-28">
      <div className="max-w-[1400px] mx-auto px-6 lg:px-10">
        <div className="grid grid-cols-1 lg:grid-cols-12 gap-10 lg:gap-16 items-center">
          {/* Left text */}
          <div className="lg:col-span-7">
            <p className="mono uppercase text-[11px] md:text-[12px] tracking-[0.22em] text-[#ED2D5C] mb-8 md:mb-10">
              {profile.taglineKicker}
            </p>

            <h1 className="font-display text-white text-[78px] sm:text-[110px] md:text-[140px] lg:text-[170px] leading-[0.88]">
              <span className="block">{profile.firstName}</span>
              <span className="block text-neutral-400">
                {profile.lastName}
                <span className="inline-block align-baseline ml-2 w-5 h-5 md:w-7 md:h-7 bg-[#ED2D5C]"></span>
              </span>
            </h1>

            <p className="text-neutral-300 text-[15px] md:text-[17px] leading-relaxed max-w-[560px] mt-8">
              Director at{' '}
              <a className="text-white underline-offset-4 hover:underline" href="https://www.weddingvideo.co.uk/">Wedding Video Essex</a>,{' '}
              <a className="text-white underline-offset-4 hover:underline" href="https://www.wvestudios.co.uk/">WVE Studios</a>{' '}
              and the{' '}
              <a className="text-white underline-offset-4 hover:underline" href={profile.groupHref}>WVE Group</a>.{' '}
              A decade of wedding photography, cinema, live event production and broadcast grade media. 900+ weddings captured on stills and film, seven industry awards, twenty six recommended venues.
            </p>

            <div className="mt-10 flex flex-wrap gap-3">
              <a
                href={`mailto:${profile.email}`}
                className="inline-flex items-center gap-2 bg-[#ED2D5C] hover:bg-[#d12551] px-5 py-3 mono text-[11px] tracking-[0.18em] text-white transition-colors"
              >
                <Mail size={14} />
                {profile.email.toUpperCase()}
              </a>
              <a
                href={profile.phoneHref}
                className="inline-flex items-center gap-2 border border-neutral-700 hover:border-[#ED2D5C] px-5 py-3 mono text-[11px] tracking-[0.18em] text-white hover:text-[#ED2D5C] transition-colors"
              >
                <Phone size={14} />
                {profile.phone}
              </a>
            </div>

            <a
              href={profile.groupHref}
              target="_blank"
              rel="noreferrer"
              className="mt-10 inline-flex items-center gap-1 mono text-[11px] tracking-[0.22em] text-neutral-500 hover:text-[#ED2D5C] transition-colors"
            >
              {profile.group} <ArrowUpRight size={13} />
            </a>
          </div>

          {/* Right photo */}
          <div className="lg:col-span-5">
            <div className="relative">
              <div className="corner-brackets">
                <span className="cb-bl" />
                <span className="cb-br" />
                <div className="aspect-[5/6] bg-neutral-900 overflow-hidden">
                  <img
                    src={profile.headshot}
                    alt={`${profile.firstName} ${profile.lastName} headshot`}
                    className="w-full h-full object-cover grayscale-[0%]"
                    loading="eager"
                  />
                </div>
              </div>
              <div className="mt-3 flex items-center justify-between mono text-[10px] tracking-[0.2em] text-neutral-500">
                <span>{`FILE · ${profile.fileMeta.name}`}</span>
                <span>
                  {`${profile.fileMeta.iso} · ${profile.fileMeta.aperture} · ${profile.fileMeta.shutter}`}
                </span>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}
